import { render, staticRenderFns } from "./StoryMakerFacebook.vue?vue&type=template&id=16b00564&"
import script from "./StoryMakerFacebook.vue?vue&type=script&lang=js&"
export * from "./StoryMakerFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports